import { css } from "@emotion/css";
import { Button, ButtonProps } from "react-aria-components";

interface Props extends ButtonProps {}

export function AvatarButton(props: Props) {
  return (
    <Button
      className={css(style.button, {
        "&[data-focused]": {
          boxShadow: "var(--focus-action)",
        },
        boxShadow: `inset 0 0 0 1px var(--border-base)`,
        backgroundColor: "var(--surface-overlay)",
      })}
      {...props}
    />
  );
}

const style = {
  button: css({
    display: "block",
    aspectRatio: 1 / 1,
    borderRadius: "var(--border-radius-half)",
    border: "none",
    padding: 0,
    margin: 0,
    outline: "none",
    background: "none",
  }),
};
